import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Params} from '@angular/router';
import {TicketArchivedDisplayState, TicketUtils} from '@app/layout/sites/tickets/ticket-utils';
import {Ticket} from '@shared/services';
import {TicketSearchQueryParams} from '../ticket-search/ticket-search-types';

@Component({
  selector: 'app-other-escalated-tickets-count',
  templateUrl: './other-escalated-tickets-count.component.html',
  styleUrls: ['./other-escalated-tickets-count.component.scss'],
  standalone: false
})
export class OtherEscalatedTicketsCountComponent implements OnChanges {

  @Input() ticket: Ticket;
  @Input() count: number;
  @Input() badge: boolean = true;
  @Input() showLink: boolean = false;
  @Input() showFullMessage = true;

  badgeColor: string;

  protected redirectToActionManagerParams: Params;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ticket) {
      this.defineRedirectToActionManagerParams(this.ticket);
    }
    if (changes.showLink) {
      this.badgeColor = this.showLink ? 'text-bg-link' : 'text-bg-info-gray';
    }
  }

  private defineRedirectToActionManagerParams(ticket: Ticket | null): void {
    this.redirectToActionManagerParams = ticket
      ? {
        [TicketSearchQueryParams.SITE_IDS]: ticket.site_id,
        [TicketSearchQueryParams.RULE_IDS]: TicketUtils.getTaskIdsFromTicket(ticket),
        [TicketSearchQueryParams.ARCHIVE_STATE]: TicketArchivedDisplayState.NOT_ARCHIVED,
      }
      : null;
  }
}
